<template>
  <div class="dr-row" :style="{'justify-content':justifyContent,'flex-flow':flexFlow,'align-items':alignItems}" @click="click">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props:{
    justifyContent:{
      type:String,
      default:'center',//'space-between：两边','space-around：居中' ，
    },
    flexFlow:{
      type:String,
      default:'wrap',//'wrap:折行','nowrap:不折行'
    },
    alignItems:{
      type:String,
      default:'',//'center：居中','end：居尾'
    },
  },
  data(){
    return {

    }
  },
  methods:{
    click() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.dr-row {
  display: flex;
  flex-flow: row;
  align-items: center;
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/drRow/index.vue